import { useCallback, useContext } from 'react';
import { getLocalCartKey } from 'src/hooks/useCart/helper';
import { fetchCartQuantity } from 'src/libs/api/cartApi';
import { AuthContext } from 'src/stores/Auth';
import { syncCart } from 'src/utils/cart';
import { getCartFromCookie } from 'src/utils/cookies';
import useSWR from 'swr';
import { useCurrentShop } from './useCurrentShop';

type Params = { isProxy: boolean };

export const useCartQuantity = ({ isProxy }: Params = { isProxy: false }) => {
  const { shopIdValue, currentShop } = useCurrentShop();
  const currentShopId = currentShop?.id ?? shopIdValue;
  const { user } = useContext(AuthContext);
  const isLoggedIn = !!user;
  const fetcher = useCallback(async () => {
    if (isProxy) return;

    if (isLoggedIn) {
      await syncCart(currentShopId);
      const response = await fetchCartQuantity();
      if (response.isLeft()) {
        throw new Error(response.value.errors.join(','));
      }
      return response.value;
    }
    return { cartTotalQuantity: getCartFromCookie().reduce((prev, current) => prev + current.quantity, 0) };
  }, [currentShopId, isLoggedIn, isProxy]);
  const { data, error, isLoading, mutate } = useSWR(
    isLoggedIn ? '/api/cart_quantity' : getLocalCartKey('/api/cart_quantity'),
    fetcher,
    {
      dedupingInterval: 0
    }
  );
  return {
    cartTotalQuantity: data?.cartTotalQuantity,
    isLoading,
    error,
    mutate
  };
};
